<template>
  <div :class="['tw-mb-3 tw-border-2 tw-px-8 tw-py-4 md:tw-py-8 tw-rounded-3xl', {'tw-border-orange-medium': props.selected}, {'tw-border-gray-300': !props.selected}]">
    <div v-if="props.location">
      <div class="tw-flex tw-justify-between tw-mb-4">
        <div class="tw-flex-1">
          <h4 class="tw-text-3xl tw-font-black tw-mt-4 md:tw-mt-0 tw-mb-6 md:tw-mb-2">{{props.location.name}}</h4>
          <div class="tw-flex tw-flex-wrap tw-mb-4 tw-text-xl">
            <div class="tw-w-1/2">
              <a :href="directionsUrl" class="tw-underline tw-mb-2 tw-block tw-mb-1" target="_blank">
                {{props.location.streetaddress}}, {{props.location.city}}, {{props.location.state}} 
              </a>
              <div>
                <a :href="'tel:'+props.location.phone" class="tw-underline">{{props.location.phone}}</a>
              </div>
            </div>
            <div class="tw-w-1/2 tw-pl-8">
              <div class="tw-mb-1" v-if="props.location.distanceFrom">{{props.location.distanceFrom}} miles away</div>
              <div>{{locationHours}}</div>
            </div>
          </div>
        </div>
        <div class="tw-flex">
          <div :class="['tw-inline-block tw-text-center', {'tw-order-2': !props.location.dispatchEnabled()}]">
            <Icon height="30" width="30" type="pickup" class="tw-inline-block"/>
            <div class="tw-uppercase tw-text-sm">Pick Up</div>
          </div>
          <div :class="['tw-inline-block tw-ml-4 tw-text-center', {'tw-opacity-0 tw-order-1': !props.location.dispatchEnabled()}]">
            <Icon height="30" width="30" type="scooter" class="tw-inline-block"/>
            <div class="tw-uppercase tw-text-sm">Delivery</div>
          </div>
        </div>
      </div>
      
      <div v-if="props.location.catering_disabled" class="tw-text-orange-medium tw-text-xl tw-mb-4">
        Online catering is not currently available at this location
      </div>

      <div>
        <TwButton 
          :cssClass="selectStoreClass"
          @emit-click="handleClick"  
          :buttonText="selectStoreText"/>

          <TwButton 
            cssClass="md:tw-ml-4 hover:tw-border-orange-medium tw-border-gray-400 tw-text-gray-400 hover:tw-text-orange-medium tw-border tw-rounded-2xl tw-uppercase tw-text-xl tw-font-black tw-px-16 tw-mb-4 md:tw-mb-0 tw-py-3 tw-transition-all tw-duration-200"
            @emit-click="storeDetails" 
            buttonText="More Details"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    computed,
  } from 'vue';

  import Location from '../../classes/Location';
  import TwButton from '../../components/TwButton.vue';

  import Icon from '../../components/Icon.vue'
  import { DateTime } from 'luxon';

  const props = defineProps({
    location: Location,
    selected: Boolean,
  })

  const emit = defineEmits(['selectLocation'])

  const handleClick = () => {
    emit('selectLocation', props.location);
  }

  const storeDetails = (event: Event) => {
    if (props.location && props.location.slug) {
      let url = "/locations/" + props.location!.slug
      window.open(url, '_blank')
    }
  }

  const selectStoreClass = computed(() => {
    let classStr = "tw-border tw-rounded-2xl tw-text-xl tw-uppercase tw-font-black tw-px-16 tw-mb-4 md:tw-mb-0 tw-py-3 tw-transition-all tw-duration-200"
    if (props.selected) {
      classStr += " tw-border-orange-medium tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white"
    } else {
       classStr += " hover:tw-border-orange-medium tw-border-gray-400 tw-text-gray-400 hover:tw-text-orange-medium"
    }
    return classStr;
  })

  const selectStoreText = computed(() => {
    if (props.selected) {
      return "Selected"
    } else {
      return "Start Your Order"
    }
  })

  const directionsUrl = computed(() => {
    let loc = props.location!;
    let url = 'https://www.google.com/maps?daddr=';

    url += loc.streetaddress;
    url += '+' + loc.city;
    url += '+' + loc.state;
    url += '+' + loc.zip;

    url = url.replace(' ', '+')

    return url;
  })

  const locationHours = computed(() => {
    const calDay = props.location!.hoursForDay('business');
    const startDt = DateTime.fromFormat(calDay.start, 'yyyyMMdd HH:mm');
    const endDt = DateTime.fromFormat(calDay.end, 'yyyyMMdd HH:mm');

    return startDt.toFormat('h:mm a') + ' - ' + endDt.toFormat('h:mm a');
  })

</script>